export const generatePDF = (nroClaringrilla) => {
  return new Promise((resolve, reject) => {
    try {
      const element = document.getElementById("gridContent"); // Obtener el elemento padre

      if (!element) {
        console.error("Elemento id 'gridContent' no encontrado.");
        reject(new Error("Elemento no encontrado"));
        return;
      }

      if (typeof html2pdf === "undefined") {
        console.error("Librería html2pdf no encontrada.");
        reject(new Error("Librería html2pdf no encontrada"));
        return;
      }

      html2pdf(element, {
        margin: [0, 2, 0, 3],
        filename: "claringrilla_Nro_" + nroClaringrilla + ".pdf",
        html2canvas: { scale: 3, scrollY: 0 },
        jsPDF: {
          unit: "mm",
          format: "a4", // Formato de página (por ejemplo, 'a4', 'letter', etc.)
          orientation: "portrait",
        },
        output: "save", // Opciones: 'save', 'download', 'arraybuffer', 'blob', 'pdfobject'
      })
        .then(() => {
          console.log("Pdf generado. Descargando...");
          resolve();
        })
        .catch((err) => {
          console.error("Error generando el PDF:", err);
          reject(err);
        });
    } catch (e) {
      console.error("Excepción al generar PDF:", e);
      reject(e);
    }
  });
};  